import parse from "html-react-parser";
import { useState } from "react";
import NextModulePreview from "./ContentModules/NextModulePreview";
import CustomModal from "./CustomModal";
import InfoRedIcon from "../images/InfoRedIcon.svg"
import { Popover } from "react-bootstrap";

const NextModuleGenericCard = (props) => {

    const { items, selectedCardHandler, selectedNextModuleList } = props;
    const [openModulePreview, setOpenModulePreview] = useState(false);
    const [ previewData, setPreviewData] = useState(null);
    const [cannotExistResult, setCannotExistResult] = useState([]);

    const nextModuleViewHandler = (items) => {
        setOpenModulePreview(true);
        setPreviewData(items)
    };

    const nextPreviewModalHideHandler = () => {
        setOpenModulePreview(false);
    }

    const filteredCanotExistModule = selectedNextModuleList.filter(f => f?.cannotExistRuleList?.find(l => l === items.id));
    const mouseHoverHandler = () => {
        let filterCannotExist = [];
        filteredCanotExistModule?.forEach(l => {
            filterCannotExist.push(l.moduleCode);
        });
        setCannotExistResult(filterCannotExist);
    }

    const mouseOutHandler = ()=> {
        setCannotExistResult([]);
    }

    return (
        <div className={`${selectedNextModuleList?.find((itemid) => itemid.id === items.id) ? "selectedNextModule": ""}
        ${(selectedNextModuleList?.filter(f => f?.cannotExistRuleList?.find(l => l === items.id)).find(f => f) ? "cannot-exist-next-module" : "")} next-module-card`}>
            <div className="cannot-exist-card-section">
                {filteredCanotExistModule?.length > 0 ? <div className="cannot-exist-text"><img src={InfoRedIcon} alt="info" onMouseOut={mouseOutHandler} onMouseEnter={mouseHoverHandler}/>Cannot Exist</div> : ""}
            </div>
            <div className="card-section">
                <div className="card-selection" onClick={() => selectedCardHandler(items)}>
                    <h6 className="next-module-card-name">Module Name</h6>
                    <p className="next-module-card-content">{items.moduleCode}</p>
                    <p className="next-module-categories-list"> <span className="next-module-card-efficacy">{items["coreCategories"] ? items["coreCategories"][0] : ''}</span></p>
                    <p className="next-module-card-claim">Claim</p>
                    <p className="next-module-card-description">{parse(items.claim || "")} </p>
                    {cannotExistResult?.length > 0 ? <div style={{ height: 120 }} className="next-module-popover">
                        <Popover
                            id="popover-basic"
                            placement="bottom"
                            positionLeft={200}
                            positionTop={50}
                            title="Popover bottom"
                        >
                            {cannotExistResult?.map(l => <p>{l}</p>)}
                        </Popover>
                    </div> : "" 
                    }
                </div>
                <hr className="next-module-card-hr" />
                <button className="btn btn-default next-module-card-view" onClick={() => nextModuleViewHandler(items)}>View</button>
            </div>
            {openModulePreview ? <CustomModal
                displayModal={openModulePreview}
                hideModal={() => {
                    nextPreviewModalHideHandler();
                }}
                title={""}
                size="xl"
                dilogClassName="next-module-modal"
                keyboard={false}
            >
                <NextModulePreview
                  previewData={previewData}
                  nextPreviewModalHideHandler={nextPreviewModalHideHandler}
                />
            </CustomModal> : ""}
        </div>
    )
}

export default NextModuleGenericCard;